import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../STATE__generation';

import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';

export const remote_user_task_duplicate = createAsyncThunkSafe<string, string>(
  ENUM__network_event_client_to_server.USER_TASK_DUPLICATE,
  async (id, thunkApi): Promise<string> => {
    return await send_to_server(ENUM__network_event_client_to_server.USER_TASK_DUPLICATE, id);
  },
);

export function init_remote_user_task_duplicate(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(remote_user_task_duplicate.pending, (state, action) => {})
    .addCase(remote_user_task_duplicate.rejected, (state, action) => {})
    .addCase(remote_user_task_duplicate.fulfilled, (state, action: PayloadAction<string>) => {});
}
